import React from "react";
import AboutUs from "./About";
import ContactUs from "./Contact";
import Footer from "./Footer";
import Header from "./Header";
import Hero from "./Hero";
import Products from "./Products";
import WhyChoose from "./WhyChoose";

export default function Dashboard() {
    return (
        <div className="bg-white text-green-900 font-sans">
            <Header />
            <Hero />
            <WhyChoose />
            <AboutUs />
            <Products />
            <ContactUs />
            <Footer />
        </div>
    )
}